'use client';
import {getApiConfig, getAuthStatus} from "@/api/api";
import {useEffect, useState} from "react";
import {MeApi} from "@/api/generated";
import {useAuth} from "@/context/AuthContext";
import ClientOnly from "@/components/client-only";
import { redirect } from 'next/navigation';

export default function Home() {
    useEffect(() => {
        redirect('/feeds/for-you');
    }, []);
    
    return null;
}